import { Component, OnInit, Input, Output, ElementRef, ChangeDetectorRef, ChangeDetectionStrategy, Renderer, EventEmitter, Inject, ViewChild } from '@angular/core';
import { ApploadServiceService } from '../../services/appload-service.service';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { StreetViewMapComponent } from '../../street-view-map/street-view-map.component';
import { SlimScrollEvent } from 'ngx-slimscroll';
import { WizardHpBaseComponent } from '../../base/wizard/wizard-hp-base-component';
import { HpService } from '../../services/hp.service';
import { Router } from '@angular/router';
import 'hammerjs';
import * as Hammer from 'hammerjs';

export interface ISlimScrollOptions {
  position?: 'left' | 'right';
  barBackground?: string;
  barOpacity?: string;
  barWidth?: string;
  barBorderRadius?: string;
  barMargin?: string;
  gridBackground?: string;
  gridOpacity?: string;
  gridWidth?: string;
  gridBorderRadius?: string;
  gridMargin?: string;
  alwaysVisible?: boolean;
  visibleTimeout?: number;
  alwaysPreventDefaultScroll?: boolean;
}

//const url_images = "/assets/images/ambiances/";
@Component({
  selector: 'app-vue-maison-mobile',
  templateUrl: './maisons-mobile.component.html',
  styleUrls: ['./maisons-mobile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MaisonMobileComponent extends WizardHpBaseComponent implements OnInit {
  @ViewChild('fileUploader', { static: false }) fileUploader:ElementRef;
  @Input() elementCurrent: string;
  @Input() viewExt: string;
  @Input() viewInt: string;
  @Input() view: string;
  menu: any;
  images = [];
  @Input() viewMap: string;
  @Output() emitView = new EventEmitter<string>();
  @Output() emitHasuploadExt = new EventEmitter<boolean>();
  @Output() emitHasuploadInt = new EventEmitter<boolean>();
  @Output() emitImageUploadExt = new EventEmitter<string>();
  @Output() emitImageUploadInt = new EventEmitter<string>();
  @Output() emitMenuRightStatut = new EventEmitter<string>();
  @Output() emitShowMap = new EventEmitter<string>();
  @Output() emitdataMap = new EventEmitter<any>();
  opts: ISlimScrollOptions;
  scrollEvents: EventEmitter<SlimScrollEvent>;
  fileData: File = null;
  idImg: string;
  imgSelected = false;
  imgUpload_selected = false;
  map_selected = false;
  format_fichier = true;
  fileUpload_name = "Fichiers jpg, png inférieur à 500ko";
  fileUpload_photo = "assets/images/icons/upload-icon.png";
  dialogDataView = [];
  mobileImages:any;
  indexImage = 0;
  visual_type ="view-0"
  dataMap = {
    "visible": 0,
    "linkposition": "48.81401494910568, 202.106446141612158",
    "heading": 132.47108163317824,
    "pitch": -10.585953782754558,
    "fov": 159
  }
  public maison_dialog_value: any;
  constructor(chgDetectorRef: ChangeDetectorRef, hpService: HpService,
    private fileUploadService: ApploadServiceService, public dialogVueMaisonRef: MatDialogRef<MaisonMobileComponent>,
    private el: ElementRef,
    router: Router,
    public dialogRef: MatDialogRef<MaisonMobileComponent>,
    public dialog: MatDialog, @Inject(MAT_DIALOG_DATA) public data_dialog: any) {
      super(chgDetectorRef, hpService, router);
    this.images = this.getHpService().getGalleryDialog();
    this.mobileImages = this.getHpService().getAmbiancesView(this.getHpService().getView());
  }

  ngOnInit() {
    super.ngOnInit();
    this.maison_dialog_value = this.data_dialog;
    console.log(this.maison_dialog_value);
    this.initHammerjs();
  }

  showMap() {
    this.viewMap = '1';

  }
 

  toggleInsideOutside(view: string) {
    this.viewExt = '204';
    this.viewInt = '213';

    switch (view) {
      case '0':
        this.emitView.emit(this.viewExt);
        this.view = '0';
        this.getHpService().setView("0");
        this.idImg = this.viewExt;
        break;
      case '1':
        this.emitView.emit(this.viewInt);
        this.idImg = this.viewInt;
        this.view = '1';
        this.getHpService().setView("1");
        break;
    }

  }

  getViewMiniature(id: string) {

    return "plgnd-sample-min-" + id + ".png";
  }

  setView(id: string) {

    switch (this.getHpService().getView()) {
      case '0':
        this.idImg = id;
        this.dataMap = this.getHpService().getConfig().data_googleMap.data;
        this.getHpService().setImageName(id);

        break;
      case '1':

        this.idImg = id;
        this.getHpService().setImageName(id);

        break;
    }
  }

  getClasses(id, id_current): string {
    return id === id_current ? "pic-showed" : "item-hidden";
  }
  getClasseActive(view): string {
    return view ? "item-underline" : "item-noUnderline";
  }
  getClasseImageActive(view): string {
    return view ? "overlay-backdrop-maison" : "no-overlay-backdrop-maison";
  }



  /*
  ** function Init Accessing Street View
  */

  openDialogMap() {
    const dialogRef = this.dialog.open(StreetViewMapComponent, {
      panelClass: 'dialog-map', disableClose: true,
      data: { name: "googleMap" }
    });

    dialogRef.afterClosed().subscribe(result => {
   
      this.format_fichier = true;
      this.dialogDataView = [];
      let data = { "vue": "0", "type": "googleMap", "data": result }
      if (this.getHpService().getTypeVisuel('0') === "googleMap") {
        this.dialogDataView.push(data);
        this.dataMap = this.getHpService().getDataMap();
        //this.getHpService().setImageName(result);
        this.map_selected = true;
        this.visual_type = "googleMap";
        if (this.dataMap.visible === 1) {
          this.fileUploader.nativeElement.value = null;
        }
        this.fileUpload_photo = (this.dataMap.visible === 1) ? "https://maps.googleapis.com/maps/api/streetview?size=640x360&location=" +
          this.dataMap.linkposition + "&heading=" + this.dataMap.heading + "&fov=" +
          this.dataMap.fov + "&pitch=" + this.dataMap.pitch + "&key="+ this.getHpService().getConfig().data_googleMap.key : this.fileUpload_photo;
          this.fileUpload_name = (this.dataMap.visible === 1) ? "" : this.fileUpload_name;
          this.getHpService().setTypeVisuel('googleMap');
        this.getChangeDetectorRef().detectChanges();
        this.getHpService().emitDataChange();
      }
    });

  }
  closeMenu() {
    this.emitMenuRightStatut.emit("in");

  }


  selectView(vue: string, id: string) {
    this.getHpService().emitDataChange();
    this.dataMap = this.getHpService().getConfig().data_googleMap.data;
    this.dialogDataView = [];
    this.idImg = id;
    this.imgSelected = true;
    this.imgUpload_selected = false;
    this.visual_type = "view-0";
    this.fileUpload_photo = this.getHpService().getAssetsPath() + "/assets/images/icons/upload-icon.png";
    let data = {
      "vue": this.getHpService().getView(),
      "type": "view-" + this.getHpService().getView(), "data": id
    }
    this.getHpService().setImageName(id)
    this.getHpService().emitDataChange();
    this.getChangeDetectorRef().detectChanges();
    //this.getHpService().setVisual_type("view-0");
    this.dialogDataView.push(data);
   

  }

  /*
  ** Event inpur file Change
  */
  onFileChange(event) {

    let reader = new FileReader();
    this.format_fichier = true;
    if (event.target.files && event.target.files.length > 0) {
      let file = event.target.files[0];
      console.log(file.name);
      if(file.type !=="image/png" && file.type !== "image/jpeg")
      {
        this.format_fichier = false;
        this.getHpService().emitDataChange();
        return;
      }
      this.fileUpload_name = file.name;
      let me = this;
      reader.readAsDataURL(file);
      let self = this;
      reader.onload = () => {
        self.fileUpload_photo = reader.result.toString();
        self.imgSelected = false;
        self.imgUpload_selected = true;
        self.dialogDataView = [];
        let data = {
          "vue": self.getHpService().getView(), "type": "upload-" + self.getHpService().getView(),
          "data": self.fileUpload_photo
        }
        self.dialogDataView.push(data);
        switch (self.getHpService().getView()) {
          case '0':
            self.getHpService().setIsUploadExt(true);
            self.getHpService().setImageName(self.fileUpload_photo);
            self.getHpService().setVisual_type("upload-0");
            self.visual_type = "upload-0";
            self.getChangeDetectorRef().detectChanges();
            self.getHpService().emitDataChange();
            break;
          case '1':
            self.getHpService().setIsUploadInt(true);
            self.getHpService().setImageName(self.fileUpload_photo);
            self.getHpService().setVisual_type("upload-1");
            self.visual_type = "upload-1";
            self.getChangeDetectorRef().detectChanges();
            self.getHpService().emitDataChange();
           
            break;
        }



        self.getHpService().setImageName(reader.result.toString());
        self.getHpService().emitDataChange();
      };
    }
    this.getHpService().emitDataChange();
  }
  closeWithouEmit() {
    return;
    this.dialogDataView = [];


    switch (this.getHpService().getVisual_type()) {
      case "view-0":
      case "upload-0":
        {

          this.imgSelected = true;
          this.imgUpload_selected = false;
          this.getHpService().setIsUploadExt(false);
          //let vue = this.getHpService().getConfig().sample_outside;
          
          //this.getHpService().setImageName(vue);
          this.getHpService().setVisual_type("view-0");
          let data = {
            "vue": this.getHpService().getView(), "type": "view-0",
            "data": this.getHpService().getImageName(this.getHpService().getView)
          }
          this.dialogDataView = [];
          this.dialogDataView.push(data);
          this.getHpService().setIsUploadExt(false);



          break;
        }
      case "view-1":
      case "upload-1":
        {
          this.getHpService().setIsUploadInt(false);
          let vue = this.getHpService().getConfig().sample_inside;
          this.getHpService().setImageName(vue);
          this.getHpService().setVisual_type("view-1");
          let data = {
            "vue": '1', "type": "view-1",
            "data": this.getHpService().getImageName(this.getHpService().getView)
          }
          this.dialogDataView = [];
          this.dialogDataView.push(data);
          this.getHpService().setIsUploadInt(false);



          break;
        }

    }
    this.dialogRef.close(this.dialogDataView);
  }


  confirmeView() {
    switch (true) {
      case this.imgSelected:
        {
          console.log(" image slected" + this.idImg)
          this.getHpService().setImageName(this.idImg);
          this.getHpService().setIsUploadExt(false);
          this.getHpService().setTypeVisuel('view-0')
          
          break;

        }
      case this.imgUpload_selected:
        {
          console.log(" image imgUpload_selected")
          this.getHpService().setVisual_type("upload-" + this.getHpService().getView());
          break;
        }
      case this.getHpService().getTypeVisuel('0') === "googleMap":
        {
          console.log("googlemap")
          this.getHpService().setImageName(this.getHpService().getConfig().sample_outside);
          break;
        }
    }
    this.getChangeDetectorRef().markForCheck();
  }

  getView() {
    return this.getHpService().getView();

  }

  mobileScrollLeft() {
    let next_index = this.indexImage + 1;
    let prev_index = this.indexImage;
    this.indexImage++;
    if (this.indexImage > this.mobileImages.length - 1) {
      this.indexImage = 0;
      next_index = 0;
      prev_index = this.mobileImages.length - 1;
    }


    let prev_imgId = document.getElementById('image-' + prev_index) as HTMLInputElement;
    let next_imgId = document.getElementById('image-' + next_index) as HTMLInputElement;
    prev_imgId.style.left = "-200%";
    next_imgId.style.left = "0";
    prev_imgId.style.zIndex = "1";
    next_imgId.style.zIndex = "100";
  }
  mobileScrollRight() {
    console.log(this.indexImage)
    var next_index = this.indexImage;//0
    var prev_index = this.indexImage - 1;
    this.indexImage--;
    if (this.indexImage < 0) {
      this.indexImage = this.mobileImages.length - 1;
      prev_index = this.mobileImages.length - 1;
      next_index = 0;
    }
    let prev_imgId = document.getElementById('image-' + prev_index) as HTMLInputElement;
    let next_imgId = document.getElementById('image-' + next_index) as HTMLInputElement;
    prev_imgId.style.left = "0";
    prev_imgId.style.zIndex = "100"
    next_imgId.style.left = "200%";
    //this.indexImage = this.indexImage >= 0 ? this.indexImage : this.mobileImages.length -1;
  }
  initHammerjs() {
    var pic = document.getElementById("picter-swipe");

    var hammertimeLeft = new Hammer.Manager(pic, {
      recognizers: [
        [Hammer.Swipe, {
          direction: Hammer.DIRECTION_LEFT
        }]
      ]
    });
    let me = this;
    hammertimeLeft.on("swipe", function (ev) {
      
      me.mobileScrollRight();

    });

    var hammertimeRight = new Hammer.Manager(pic, {
      recognizers: [
        [Hammer.Swipe, {
          direction: Hammer.DIRECTION_RIGHT
        }]
      ]
    });

    hammertimeRight.on("swipe", function (ev) {

      me.mobileScrollLeft();

    });

  }

  removeImgUploadMap() {
    this.fileUploader.nativeElement.value = null;
    this.imgUpload_selected = false;
    this.getHpService().setTypeVisuel('view-0'),
    this.visual_type ='view-0';
    this.fileUpload_photo = "assets/images/icons/upload-icon.png";
    this.fileUpload_name = "Votre image jpg, png";
    this.dataMap = {
      "visible": 0,
      "linkposition": "46.98123233164222,1.805750207787383",
      "heading": 108.76767031965346,
      "pitch": 2.8858925347222737,
      "fov": 159
    };
    this.getHpService().setIsUploadExt(false);
    this.getHpService().setImageName(this.getHpService().getImageName('0'));

  }
}
